import {
  Button, Flex, Text
} from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';
import { footerStyles } from './styles.css';

export const Footer = ({
  handleClick,
  isLoading,
  formHasErrors,
  isAllFieldDisabled,
}: {
  handleClick: () => void;
  isLoading: boolean;
  formHasErrors: boolean;
  isAllFieldDisabled: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      data-testid='edit-vault-form-footer'
      className={ footerStyles }
      justify='space-between'
      align='center'
      bg='blue.50'
      my='3'
    >
      {formHasErrors
        ? (
          <Text color='text-error-primary_alt' size='md'>
            {t('kyc.footer.fixErrors')}
          </Text>
        )
        : (
          <Text color='text-secondary' size='md'>
            {t('kyc.footer.description')}
          </Text>
        )}
      <Button
        variant='outline'
        onClick={ handleClick }
        loading={ isLoading }
        data-test='submit-on-clients-behalf-btn'
      >
        {t(`kyc.footer.${isAllFieldDisabled ? 'fillBtn' : 'saveBtn'}`)}
      </Button>
    </Flex>
  );
};
